import './$layout.css.proxy.js';
/* src/routes/$layout.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	create_bidirectional_transition,
	create_component,
	create_slot,
	destroy_component,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	space,
	transition_in,
	transition_out,
	update_slot
} from "../../web_modules/svelte/internal.js";

import Nav from "../../_components/Nav.js";
import Footer from "../../_components/Footer.js";
import { fade } from "../../web_modules/svelte/transition.js";

function create_fragment(ctx) {
	let div;
	let nav;
	let t0;
	let div_transition;
	let t1;
	let footer;
	let current;
	let mounted;
	let dispose;
	nav = new Nav({ props: { selected: /*selected*/ ctx[0] } });
	const default_slot_template = /*#slots*/ ctx[3].default;
	const default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ ctx[2], null);
	footer = new Footer({});

	return {
		c() {
			div = element("div");
			create_component(nav.$$.fragment);
			t0 = space();
			if (default_slot) default_slot.c();
			t1 = space();
			create_component(footer.$$.fragment);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(nav.$$.fragment, div_nodes);
			t0 = claim_space(div_nodes);
			if (default_slot) default_slot.l(div_nodes);
			div_nodes.forEach(detach);
			t1 = claim_space(nodes);
			claim_component(footer.$$.fragment, nodes);
			this.h();
		},
		h() {
			attr(div, "class", "body svelte-hjmu02");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(nav, div, null);
			append(div, t0);

			if (default_slot) {
				default_slot.m(div, null);
			}

			insert(target, t1, anchor);
			mount_component(footer, target, anchor);
			current = true;

			if (!mounted) {
				dispose = [
					listen(window, "click", handleClick),
					listen(window, "scroll", handleScroll)
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			const nav_changes = {};
			if (dirty & /*selected*/ 1) nav_changes.selected = /*selected*/ ctx[0];
			nav.$set(nav_changes);

			if (default_slot) {
				if (default_slot.p && dirty & /*$$scope*/ 4) {
					update_slot(default_slot, default_slot_template, ctx, /*$$scope*/ ctx[2], dirty, null, null);
				}
			}
		},
		i(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(default_slot, local);

			add_render_callback(() => {
				if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, true);
				div_transition.run(1);
			});

			transition_in(footer.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(default_slot, local);
			if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, false);
			div_transition.run(0);
			transition_out(footer.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(nav);
			if (default_slot) default_slot.d(detaching);
			if (detaching && div_transition) div_transition.end();
			if (detaching) detach(t1);
			destroy_component(footer, detaching);
			mounted = false;
			run_all(dispose);
		}
	};
}

function handleClick() {
	
}

function handleScroll() {
	
}

function instance($$self, $$props, $$invalidate) {
	let { $$slots: slots = {}, $$scope } = $$props;
	let { selected = "/" } = $$props;
	let { title = "home" } = $$props;

	$$self.$$set = $$props => {
		if ("selected" in $$props) $$invalidate(0, selected = $$props.selected);
		if ("title" in $$props) $$invalidate(1, title = $$props.title);
		if ("$$scope" in $$props) $$invalidate(2, $$scope = $$props.$$scope);
	};

	return [selected, title, $$scope, slots];
}

class $layout extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { selected: 0, title: 1 });
	}
}

export default $layout;
//# sourceMappingURL=$layout.js.map
